import { useQuery } from "@tanstack/react-query";

import { getSupabaseClient } from "../providers/supabase/supabase";

/**
 * «No contesta» cycle (4 nov 2026): before a lead goes to Reactivar the
 * setters must really try — 3 calls in at least 2 slots and WhatsApp on 3
 * different days — or it goes by itself after a week. Keep in sync with
 * gula_no_answer_exhausted().
 */
export const CYCLE = { calls: 3, slots: 2, waDays: 3, days: 7 };

export interface NoAnswerProgress {
  client_id: number;
  calls: number;
  call_slots: number;
  wa_days: number;
  last_reply_at?: string | null;
}

/** "Llamadas 2/3 · 1 de 2 franjas · WhatsApp 1/3" and what is missing. */
export const progressText = (progress: NoAnswerProgress) => {
  const calls = Math.min(progress.calls, CYCLE.calls);
  const slots = Math.min(progress.call_slots, CYCLE.slots);
  const wa = Math.min(progress.wa_days, CYCLE.waDays);
  const missing = [
    calls < CYCLE.calls ? "llamar" : null,
    slots < CYCLE.slots ? "probar otra franja" : null,
    wa < CYCLE.waDays ? "mandar WhatsApp" : null,
  ].filter(Boolean);
  return {
    line: `Llamadas ${calls}/${CYCLE.calls} · franjas ${slots}/${CYCLE.slots} · WhatsApp ${wa}/${CYCLE.waDays}`,
    next: missing.length ? `Falta: ${missing.join(", ")}` : null,
  };
};

export const useNoAnswerProgress = () => {
  const { data = [] } = useQuery({
    queryKey: ["gula-no-answer-progress"],
    refetchInterval: 60_000,
    queryFn: async () => {
      const { data, error } = await getSupabaseClient()
        .from("gula_no_answer_progress")
        .select("client_id,calls,call_slots,wa_days,last_reply_at")
        .limit(2000);
      if (error) throw error;
      return (data ?? []) as NoAnswerProgress[];
    },
  });
  const byId = new Map(data.map((row) => [String(row.client_id), row]));
  return (clientId: unknown) => byId.get(String(clientId));
};
